<div class="phone-input-container">
  <div class="form-group flex row">
    <div class="col-4">
      <ng-select
        [items]="countryOptions"
        bindLabel="label"
        [ngModel]="selectedCountry"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onCountryChange($event)"
        class="form-control shadow-none p-0"
        [disabled]="readonly"
        [clearable]="false"
        [searchable]="true"
        [searchFn]="searchCountry"
        [compareWith]="compareCountries"
      >
        <ng-template ng-label-tmp let-country="item">
          {{ country.iso }} {{ country.dial }}
        </ng-template>
        <ng-template ng-option-tmp let-country="item">
          {{ country.label }} ({{ country.dial }})
        </ng-template>
      </ng-select>
    </div>
    <div class="col-8">
      <input
        [ngModel]="phoneNumber"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onPhoneNumberInput($event)"
        (blur)="onInputBlur()"
        class="form-control shadow-none"
        type="tel"
        inputmode="tel"
        autocomplete="tel"
        [attr.placeholder]="selectedCountry.format"
        [readonly]="readonly"
      />
    </div>
  </div>
</div>
